module.exports = __webpack_public_path__ + "media/images/emblems/GW-FR-Les-Montets-5573174cb7adbe0dee5a129fa6694a91.png";